import CryptoJS from 'crypto-js'

// Function to generate a random salt
const generateSalt = (length = 16) => {
  return CryptoJS.lib.WordArray.random(length).toString()
}

// Function to encrypt a string with salt
const encryptString = (text: string, salt: string) => {
  // Combine the text with the salt
  const saltedText = text + salt
  // Encrypt using AES
  return CryptoJS.AES.encrypt(saltedText, salt).toString()
}

// Function to decrypt a string with salt
const decryptString = (encryptedText: string, salt: string) => {
  try {
    // Decrypt using AES
    const decrypted = CryptoJS.AES.decrypt(encryptedText, salt)
    // Convert to string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
    // Remove the salt from the end
    return decryptedText.slice(0, -salt.length)
  } catch (error) {
    console.error('Decryption failed:', error)
    return null
  }
}

export { generateSalt, encryptString, decryptString }
